const minDateValidation = (
    selectedMonth:number, 
    requiredMinMonth:Number,
    selectedYear:number,
    requiredMinYear:number
) : boolean => 
{

    if(
        selectedMonth >= requiredMinMonth
            &&
        selectedYear == requiredMinYear
    ){
        return true;
    }else{
        return false;
    }

}

const maxDateValidation = (
    selectedMonth:number, 
    requiredMaxMonth:number,
    selectedYear:number,
    requiredMaxYear:number,
    requiredMinYear:number
    ) : boolean => 
{
    if(
        selectedMonth <= requiredMaxMonth
            &&
        selectedYear == requiredMaxYear
            &&
        requiredMinYear !== requiredMaxYear
    ){
        return true;
    }else{
        return false;
    }
}

const intervalYearValidation = (
    selectedYear:number, 
    startYear:number, 
    endYear:number
    ): boolean => 
{
    if(
        selectedYear > startYear
            &&
        selectedYear < endYear
    ){
        return true;
    }else{
        return false;
    }
}

export const DateValidation = (
    selectedMonth:number,
    selectedYear:number,
    requiredMinMonth:number,
    requiredMinYear: number,
    requiredMaxMonth:number,
    requiredMaxYear:number
) : boolean => {
    const isValid:boolean = 
        intervalYearValidation(selectedYear, requiredMinYear, requiredMaxYear) 
            ||
        minDateValidation(selectedMonth, requiredMinMonth, selectedYear, requiredMinYear) 
            ||
        maxDateValidation(selectedMonth, requiredMaxMonth, selectedYear, requiredMaxYear, requiredMinYear)
    
    return isValid;
}